import TopBar from "@/components/TopBar";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import WhyChooseUs from "@/components/WhyChooseUs";

import ReviewWidget from "@/components/ReviewWidget";
import ServiceAreas from "@/components/ServiceAreas";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import { usePageMeta } from "@/lib/seo";
import { site } from "@/lib/site";

const homepageFaqs = [
  { q: "Do you offer free estimates?", a: "Yes. Every project starts with a free, no-pressure, on-site estimate. We'll measure your property, talk through your options, and give you clear pricing before you decide anything." },
  { q: "What areas do you serve?", a: "We're based in Dillon and serve all of Summit County within a roughly 30-mile radius — including Silverthorne, Frisco, Breckenridge, Keystone, Copper Mountain, and nearby communities." },
  { q: "What types of fences do you install?", a: "Wood and cedar privacy fences, picket fences, chain link, aluminum and custom-designed fencing, plus construction and perimeter fencing. We also repair existing fences and install gates." },
  { q: "How do your fences hold up to Colorado winters?", a: "That's our specialty. We set posts to a proper frost depth in well-drained footings and choose materials built for snow load, wind, and freeze-thaw cycles so your fence stays straight and solid." },
  { q: "Can you repair my existing fence instead of replacing it?", a: "Often, yes. We reset leaning posts, replace damaged panels and pickets, and rebuild gates. We'll give you honest advice on whether a repair or a full replacement is the smarter option." },
  { q: "Do you install gates and hardware?", a: "Absolutely — walk-through gates, rolling and swing drive gates, latches, hinges, and hardware, all sized and fitted to match your fence." },
  { q: "How long does a fence installation take?", a: "It depends on the length, terrain, and material, but most residential fences are completed in a few days. We'll give you a realistic timeline with your estimate." },
  { q: "Do you offer any discounts?", a: "Estimates are always free, and we run a neighbor referral reward — when someone you refer books a fence with us, you both earn a reward." },
];

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: site.name,
    image: `${site.url}/og-image.png`,
    url: site.url,
    telephone: site.phone,
    email: site.email,
    address: {
      "@type": "PostalAddress",
      addressLocality: site.city,
      addressRegion: site.stateAbbr,
      addressCountry: "US",
    },
    areaServed: site.serviceArea,
    openingHoursSpecification: [
      { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "07:00", closes: "19:00" },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Saturday", opens: "07:00", closes: "17:00" },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: homepageFaqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  },
];

const Index = () => {
  usePageMeta({
    title: "Fence Installation in Dillon, CO | Summit Neighbor",
    description:
      "Summit Neighbor Fencing Co. installs and repairs wood, picket, chain link, and aluminum fences in Dillon and across Summit County, Colorado. Free estimates.",
    path: "/",
    jsonLd,
  });
  return (
    <div className="min-h-screen bg-background">
      <TopBar />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <WhyChooseUs />
        
        <ReviewWidget />
        <ServiceAreas />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
